module.exports = __webpack_public_path__ + "img/picture-air-desktop-mobile.a023f77b.jpg";